module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mainNavigation"
  }, [_c('nav', {
    staticClass: "navbar navbar-dark",
    style: ('background-color: ' + _vm.backgroundColor)
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "collapse navbar-toggleable-xs",
    attrs: {
      "id": "collapseEx"
    }
  }, [(this.hideLogo === false) ? _c('router-link', {
    staticClass: "navbar-brand",
    attrs: {
      "to": '/' + this.$store.state.language
    }
  }, [_vm._v("booknatura")]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav pull-right"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [(_vm.page !== 'mainPage') ? _c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/"
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]) : _vm._e()], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/' + this.$store.state.language + '/login'
    }
  }, [_vm._v(_vm._s(_vm.t('login')))])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/' + this.$store.state.language + '/supplier/register'
    }
  }, [_vm._v(_vm._s(_vm.t('register')))])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/' + this.$store.state.language + '/supplier/'
    }
  }, [_vm._v(_vm._s(_vm.t('suppliers')))])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item btn-group"
  }, [_c('a', {
    staticClass: "nav-link dropdown-toggle",
    attrs: {
      "id": "dropdownMenu1",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v(_vm._s(_vm.t('change language')))]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu",
    attrs: {
      "aria-labelledby": "dropdownMenu1"
    }
  }, [_c('a', {
    staticClass: "dropdown-item",
    on: {
      "click": function($event) {
        _vm.setLanguage('pt')
      }
    }
  }, [_vm._v("português")]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item",
    on: {
      "click": function($event) {
        _vm.setLanguage('en')
      }
    }
  }, [_vm._v("english")])])]), _vm._v(" "), _c('UserMenu'), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  })], 1)], 1)])]), _vm._v(" "), (_vm.showPromoterNav) ? _c('SecondaryNavigation') : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "navbar-toggler hidden-sm-up",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#collapseEx"
    }
  }, [_c('i', {
    staticClass: "fa fa-bars"
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-237ec656", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-237ec656"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/Navigation/Navigation.vue
// module id = 765
// module chunks = 3